import { render, staticRenderFns } from "./JpmbStudent.vue?vue&type=template&id=5163b3ec&scoped=true&"
import script from "./JpmbStudent.vue?vue&type=script&lang=js&"
export * from "./JpmbStudent.vue?vue&type=script&lang=js&"
import style0 from "./JpmbStudent.vue?vue&type=style&index=0&id=5163b3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163b3ec",
  null
  
)

export default component.exports